import { compareCompositeAgreement } from "@/metrics/registry"

import type { MetricMetadata } from "@/types/metrics/metadata"

interface CompositeComparisonSource {
  float_value?: number | null
  set_value?: string[] | null
  result?: Record<string, unknown> | null
  result_json?: Record<string, unknown> | null
}

interface CompositeHumanReviewSource {
  float_value?: number | null
  set_value?: string[] | null
  json_value?: Record<string, unknown> | null
}

export const hasCompositeAgreementConflict = (
  source: CompositeComparisonSource,
  humanReview: CompositeHumanReviewSource,
  metricMetadata?: MetricMetadata,
  criteriaViewMode: "score" | "criteria" = "criteria",
): boolean => {
  const outcome = compareCompositeAgreement(
    source,
    humanReview,
    metricMetadata,
    criteriaViewMode,
  )

  if (outcome.kind === "per-criterion") {
    return outcome.total > 0 && outcome.matching < outcome.total
  }
  return outcome.kind === "aggregate" && !outcome.agrees
}
